import { render, staticRenderFns } from "./RestoreEventDialog.vue?vue&type=template&id=3399228f"
import script from "./RestoreEventDialog.vue?vue&type=script&lang=js"
export * from "./RestoreEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports